import { createDraftSafeSelector } from '@reduxjs/toolkit';
import type { RootState } from '@src/store/reduxstore';

const codesWithAgentFullname = ['AGENT_REQUESTED_CHAT', 'AGENT_PICKED_UP_CHAT'];

export const standardMessagesSelector = (state: RootState) =>
  state.standardMessages;

export const standardMessagesByCodeSelector =
  (code: string) => (state: RootState) =>
    state.standardMessages.messages.find(
      message => message.standardMessage.code === code
    );

export const standardMessagesFixedSelector = createDraftSafeSelector(
  standardMessagesSelector,
  state =>
    state.messages.map(
      ({ botId, enabled, standardMessage: { code, value } }) => ({
        botId,
        enabled,
        code,
        value: codesWithAgentFullname.includes(code)
          ? value.replaceAll(`\${AGENT_FULL_NAME}`, '{0}')
          : value,
      })
    )
);
